module.exports = __webpack_public_path__ + "static/media/ReelInMotion.19f8f7bc.jpg";